import Select from "../../../common/Select";

export default function GlobalOrganizationSelect(props: {
  orgs: { id: string; email: string }[];
  selectedOrgId?: string;
  onChange: (orgId?: string) => void;
}) {
  return (
    <Select
      selected={props.selectedOrgId}
      backgroundColor={"black"}
      items={[
        { value: undefined, label: "My org" },
        ...props.orgs.map((org) => ({
          value: org.id,
          label: org.email,
        })),
      ]}
      onChange={(value) => props.onChange(value as string | undefined)}
    />
  );
}
